import BaseUseCase from "../../base_use_case.js";

class CurrentUserQuestionnaireUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/users/questionnaires/current_user`
    });
  }
}

const instance = new CurrentUserQuestionnaireUseCase();
export default instance;